import "@expo/metro-runtime";
import "./global.css";
// Must run before the first render so every Pressable picks up the shim.
import "./nativewindPressableStyleFix";
import { registerRootComponent } from "expo";
import { Platform } from "react-native";
import App from "./App";

// Load react-grab in development on web only
if (__DEV__ && Platform.OS === "web") {
  import("react-grab");
}

registerRootComponent(App);
